export const urls = {
  linkedIn: "https://www.linkedin.com/in/arjun-a-nair-74194536/",
  gitHub: "https://github.com/developer-arjunnair",
  gmail: "mailto:aku2anu@gmail.com"
};
